import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { BannerLayout } from './BannerLayout';

const useGetAllPlansIncludedFeatures = () => {
  const p3Context = PremiumPurchasePlatformModule.internals.useContext();
  return PremiumPurchasePlatformModule.SDK.ApiClient.hooks.useGetAllPlansIncludedFeatures(
    p3Context,
  );
};

export const AllPlansIncludedFeaturesBanner = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { data } = useGetAllPlansIncludedFeatures();

  return (
    <BannerLayout
      title={t('studio_package_picker.banner.all_plans_include.title')}
      items={data?.features?.map((item) => t(item.featureName ?? '')) ?? []}
    />
  );
};
